module.exports = __webpack_public_path__ + "images/customer-images/customer-image4.png";